import { object, string } from "yup";

export type DietitianClinicBillingProfileType = "person" | "company";

export interface DietitianClinicBillingProfileResource {
  type: DietitianClinicBillingProfileType;
  companyName: string | null;
  taxId: string | null;
  firstName: string | null;
  lastName: string | null;
  country: string;
  postcode: string;
  city: string;
  addressLine: string;
  billingEmail: string | null;
}

export const dietitianClinicBillingProfileResourceSchema = object({
  type: string().oneOf(["person", "company"]).required(),
  companyName: string().nullable().default(null),
  taxId: string().nullable().default(null),
  firstName: string().nullable().default(null),
  lastName: string().nullable().default(null),
  country: string().required(),
  postcode: string().required(),
  city: string().required(),
  addressLine: string().required(),
  billingEmail: string().nullable().default(null),
});
